import React from 'react';
import Button from 'material-ui/Button';
import {connect} from "react-redux";
import serverRequest from '../service/serverRequest';
import ProgressCircle from  './ProgressCircle';
import {setSend,setGotResponse,gotError} from "../actions/process";
import {LOGIN} from "../reducers/filters";
import {LOGIN_PORT} from "../store/configureStore";
import {setCurPage, setClearResults, setCount} from '../actions/filters';


const RequestButton=({process,filters, data, dispatch,caption,path,handleData, user, paginationEventType})=>{
    return <div>
        {process.waiting ? (<ProgressCircle size={30}/>)
            :(<Button variant="raised" color="primary" className='common-btn'
                      onClick={()=>{
                          dispatch(setSend());

                          dispatch(setCurPage(1));
                          var clearKey = path.replaceAll('/', '');
                          dispatch(setClearResults(clearKey, false));

                          const f = {...filters, path, port : path === LOGIN ? LOGIN_PORT : filters.port, }

                          // filters.path=path;
                          //
                          // filters.port = path === LOGIN ? LOGIN_PORT : filters.port;

                          serverRequest(
                              f, (code,resp)=>{
                                  dispatch(handleData(JSON.parse(resp)));
                                  dispatch(setGotResponse('DATE_USERS'));
                              }, error=>{dispatch(gotError(error))},
                              user, data, paginationEventType, path === LOGIN
                          );
                      }}>
                {caption}
            </Button>)}
    </div>
};

const mapStateToProps=(state)=>({filters:state.filters, process:state.process, user: state.user, data: state.data});
const ConnectedRequestButton=connect(mapStateToProps)(RequestButton);
export default ConnectedRequestButton;